import type AppState from 'src/types/appState';

export const classifyPageSelector = (state: AppState) => ({
  isPageReady: Boolean(
    state.tealium.userId &&
      state.tealium.advertiser &&
      state.tealium.advertiser.type &&
      state.tealium.advertiser.pricingType &&
      state.tealium.hirerPurchaseType &&
      state.tealium.seekAdvertiserId,
  ),
});
